export default __webpack_public_path__ + "static/media/image_banner_nft_07042022.2263f68e.png";